import { FC, ReactNode } from 'react'

type layoutProps = {
  children: ReactNode
  container: 'padding' | 'full' | 'center' | 'legacy' | 'legacy-large'
}

const Layout: FC<layoutProps> = ({ children, container }) => (
  <div className={`layout ${container}`}>{children}</div>
)

export default Layout
